import { Scissors } from "lucide-react";
import { formatINR } from "../lib/api";

export function LRSplitModal({ lr, lrItems, vehicles, splitItems, setSplitItems, splitVehicles, setSplitVehicles, splitNumber, setSplitNumber, splitFreight, setSplitFreight, splitting, doSplit, toggle, onClose }) {
  return (
    <div className="fixed inset-0 bg-black/50 z-40 flex items-start justify-center overflow-y-auto py-8" data-testid="lr-split-modal">
      <div className="bg-white w-full max-w-2xl mx-4">
        <div className="px-6 py-4 border-b border-[#E5E3DB] flex items-center justify-between">
          <h2 className="font-headings text-xl font-bold flex items-center gap-2"><Scissors className="w-5 h-5" /> Split {lr.lr_number}</h2>
          <button className="btn-ghost" onClick={onClose} data-testid="lr-split-close">×</button>
        </div>
        <div className="p-6 space-y-6">
          <p className="text-sm text-[#68665E]">Tick the items and vehicles to MOVE into a brand-new LR. The selected cargo leaves this LR; everything unticked stays here.</p>

          <div>
            <div className="section-title">Items to move</div>
            {lrItems.length === 0 ? <div className="text-[11px] text-[#A09E96]">No items on this LR.</div> : (
              <div className="border border-[#E5E3DB] divide-y divide-[#F0EDE5]">
                {lrItems.map((it, i) => (
                  <label key={i} className="flex items-center gap-3 px-3 py-2 text-sm hover:bg-[#FAFAF9] cursor-pointer">
                    <input type="checkbox" checked={splitItems.includes(i)} onChange={() => toggle(splitItems, setSplitItems, i)} data-testid={`lr-split-item-${i}`} />
                    <span className="flex-1">{it.description || "—"} · {it.quantity || 0} {it.unit || "Nos"}</span>
                    <span className="text-[#68665E]">{it.weight_kg ? `${it.weight_kg} kg` : ""}</span>
                  </label>
                ))}
              </div>
            )}
          </div>

          <div>
            <div className="section-title">Vehicles to move</div>
            {vehicles.length === 0 ? <div className="text-[11px] text-[#A09E96]">No vehicles on this LR.</div> : (
              <div className="border border-[#E5E3DB] divide-y divide-[#F0EDE5]">
                {vehicles.map((v, i) => (
                  <label key={i} className="flex items-center gap-3 px-3 py-2 text-sm hover:bg-[#FAFAF9] cursor-pointer">
                    <input type="checkbox" checked={splitVehicles.includes(i)} onChange={() => toggle(splitVehicles, setSplitVehicles, i)} data-testid={`lr-split-vehicle-${i}`} />
                    <span className="font-mono flex-1">{v.vehicle_number || "—"}</span>
                    <span className="text-[#68665E]">{v.driver_name || ""}</span>
                  </label>
                ))}
              </div>
            )}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div><label className="input-label">New LR Number (blank = auto)</label><input className="input-field font-mono" value={splitNumber} onChange={(e) => setSplitNumber(e.target.value)} placeholder="Auto-generate" data-testid="lr-split-number" /></div>
            <div><label className="input-label">Freight to move (Rs.)</label><input type="number" step="0.01" className="input-field" value={splitFreight} onChange={(e) => setSplitFreight(e.target.value)} data-testid="lr-split-freight" /><p className="text-[11px] text-[#68665E] mt-1">Deducted from this LR's freight ({formatINR(lr.freight_amount)}).</p></div>
          </div>

          <div className="flex justify-end gap-3 pt-4 border-t border-[#E5E3DB]">
            <button type="button" className="btn-secondary" onClick={onClose}>Cancel</button>
            <button type="button" disabled={splitting} className="btn-primary" onClick={doSplit} data-testid="lr-split-confirm">{splitting ? "Splitting..." : "Split into new LR"}</button>
          </div>
        </div>
      </div>
    </div>
  );
}
